import { Badge, Tooltip } from '@/components/ui';

/** recorded / queued / failed — the three outcomes an Anatomy write can have. */
export function ResultBadge({ success, queued, message }: { success: boolean; queued: boolean; message?: string | null }) {
  if (!success) return <Tooltip label={message ?? ''} disabled={!message}><Badge color="red" variant="light">failed</Badge></Tooltip>;
  return queued ? <Badge color="yellow" variant="light">queued</Badge> : <Badge color="green" variant="light">recorded</Badge>;
}
